import React, {FC, useEffect, useState} from "react";
import {LoadPanel} from "devextreme-react/load-panel";
import DataGrid, {Column, Paging, SearchPanel} from "devextreme-react/data-grid";
import {useTypedSelector} from "../reducers";
import axios from "axios";
import moment from "moment";
import {handleError} from "../error/ErrorHandler";

const AdminLoginLog: FC = () => {
    const {site} = useTypedSelector(state => state.profile);
    const [loading, setLoading] = useState(true);
    const [dataSource, setDataSource] = useState([]);
    const {status} = useTypedSelector(state => state.auth);

    useEffect(() => {
        if (status === 'idle') return;
        getDataSource();
    }, [status]);

    const getDataSource = async () => {
        try {
            const res = await axios.get('/api/log/login');
            if (!res.data) return;
            res.data.forEach((data: any) => {
                data['loadDtm'] = moment(data['loadDtm']).format('YYYY-MM-DD HH:mm:ss');
                data['orgYn'] = data['orgYn'] === 'Y' ? '기관' : '개인';
            })
            setDataSource(res.data);
        } catch (err) {
            handleError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`log-content-wrapper ${site}`}>
            <div className={'log-content-body'}>
                {loading &&
                <LoadPanel visible={true}/>
                }
                {!loading &&
                <DataGrid dataSource={dataSource}
                          showColumnLines={false}
                          showRowLines={true}>
                    <SearchPanel visible={true}/>
                    <Column dataField={'usrId'} caption={'사용자 아이디'} cssClass={'board-content-header text-center'}
                            alignment={'center'}/>
                    <Column dataField={'usrNm'} caption={'사용자 이름'} cssClass={'board-content-header header-center'}
                            alignment={'center'}/>
                    <Column dataField={'orgYn'} caption={'소속 여부'} cssClass={'board-content-header text-center'}
                            alignment={'center'}/>
                    <Column dataField={'orgNm'} caption={'소속 기관명'} cssClass={'board-content-header text-center'}
                            alignment={'center'}/>
                    <Column dataField={'loadDtm'} caption={'로그인 일시'} cssClass={'board-content-header text-center'}
                            alignment={'center'}/>
                    <Paging
                        defaultPageSize={10} />
                </DataGrid>
                }
            </div>
        </div>
    );
};
export default AdminLoginLog;
